import { ref } from "vue";
import md5 from "js-md5";
import request from "@/utils/request";
import { getRandomString } from "@/utils/string";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

const BASEURL = process.env.VUE_APP_BASE_API;
const SECRET = process.env.VUE_APP_SIGN_KEY;

const CAHX_BASEURL = process.env.VUE_APP_BASEURL;
// const CAHX_SIGN_KEY = process.env.VUE_APP_BASEURL_SIGN_KEY;

// 埋点上报
export function reportData(data) {
  // TODO: 抽取工具函数
  let osType = ""; // 上报操作系统
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    // 判断iPhone|iPad|iPod|iOS
    osType = 2;
  } else if (/(Android)/i.test(navigator.userAgent)) {
    // 判断Android
    osType = 1;
  } else {
    // SDK
    osType = 3;
  }

  const fingerprintRef = ref("");
  const fpPromise = FingerprintJS.load();

  (async () => {
    const fp = await fpPromise;
    const result = await fp.get();
    const visitorId = result.visitorId;
    fingerprintRef.value = visitorId;
    localStorage.setItem("visitor_id", visitorId);
  })();

  let newBody = Object.assign(
    {
      // account_id: parseInt(userInfo?.accountId) || null,
      // account_name: userInfo?.name || "",
      distinct_id: localStorage.getItem("visitor_id"),
      event_time: Math.round(new Date() / 1000),
      system_source: 1, // 系统来源，1：浏览器
      project_id: 14, // 项目id，13：交易中心
      game_id: 107,
      scene_id: null,
      referrer_scene_id: null,
      os_type: osType + "",
    },
    data
  );

  const ts = Math.round(new Date() / 1000).toString();
  const key = "1014";
  const nonce = getRandomString();
  const params = {
    body: newBody,
    sign: md5(`${SECRET}${key}${ts}${nonce}${SECRET}`),
    ts,
    key,
    nonce,
  };
  return request({
    url: `${BASEURL}/api/reporting-data`,
    method: "post",
    data: params,
  });
}

// // 点击下载上报
// export function dowloadReportData(data){
//   return request({
//     url:`${BASEURL}/api/reporting-data`
//     method:'post',
//   })
// }

/**
 * 获取文章列表
 */
export function getArticleList({ code, projectId = 107, page, pageRows }) {
  const formData = new FormData();
  formData.append("project_id", projectId);
  formData.append("code", JSON.stringify(code));
  formData.append("page", page || 1);
  formData.append("page_rows", pageRows);
  return request({
    url: `${CAHX_BASEURL}/articleList`,
    method: "post",
    data: formData,
  });
}

/**
 * 获取文章详情
 */
export function getArticleDetails({ articleId }) {
  const formData = new FormData();
  formData.append("article_id", articleId);
  return request({
    url: `${CAHX_BASEURL}/articleInfo`,
    method: "post",
    data: formData,
  });
}
